<template>
  <div class="yxtbiz-area-tree">
    <yxt-row>
      <yxt-input
        class="yxtbiz-area-tree__input"
        ref="input"
        v-model="searchText"
        :size="size"
        :style="{ width: inputW }"
        :placeholder="$t('pc_biz_shoptour_search_key').d('请输入区域名称搜索')"
        searchable
        clearable
        @search="search"
      >
      </yxt-input>
    </yxt-row>
    <yxtbiz-funs-tree
      class="mt16"
      ref="tree"
      :data="data"
      :props="defaultProps"
      :wrap-width="wrapWidth"
      :node-key="nodeKey"
      :default-expand-all="defaultExpandAll"
      :default-expanded-keys="expendedRoot"
      show-checkbox
      check-strictly
      check-on-click-node
      functions
      :functionsRender="functionsRender"
      :filter-node-method="filterNode"
      @node-click="nodeClick"
      @check="handlerCheck"
      :dropdownToBody="dropdownToBody"
      virtual
      :keeps="50"
      :buffer="10"
    />
  </div>
</template>

<script>
/**
 * @description  : 带选择的区域树(供报表使用)
 * @date         : 2022-07-05 19:38:56
 * @author       : yokiizx
 */
import { getAreaTree } from '../service';
export default {
  name: 'AreaTree',
  props: {
    // placeholder: {
    //   type: String,
    //   default: '请输入区域名称搜索'
    // },
    size: {
      type: String,
      default: 'medium' // medium || small || mini
    },
    inputW: {
      type: String,
      default: '300px'
    },
    // 已经勾选的区域
    list: {
      type: Array,
      default: () => []
    },
    // 最大选择区域树
    limit: {
      type: Number,
      default: Infinity
    },
    nodeKey: {
      type: String,
      default: 'id'
    },
    dropdownToBody: {
      type: Boolean,
      default: true
    },
    // 勾选父部门, 联动子部门及后续新增子部门 1 联动
    checkedLinkage: {
      type: String,
      default: '1'
    },
    wrapWidth: {
      type: Number,
      default: 666
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'areaName',
        disabled: data => !data.edit // 根据后端返回的edit字段来判断是否有权限操作
      },
      expendedRoot: [], // 默认展开根元素
      rootId: '1',
      currentCheckedNodes: []
    };
  },
  watch: {
    list(newVal) {
      if (newVal) {
        this.currentCheckedNodes = newVal;
        this.$refs.tree.setCheckedNodes(this.currentCheckedNodes);
        this.$refs.tree.getCheckedNodes().forEach(item => {
          if (newVal.findIndex(ele => ele.id === item.id) === -1) {
            this.$refs.tree.setChecked(item.id, false);
          }
        });
      }
    }
  },
  async mounted() {
    await this.getAreaTree();
  },

  methods: {
    /**
     * 搜索区域树
     */
    search(value) {
      this.$refs.tree.filter(value);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.areaName.indexOf(value) !== -1;
    },
    /**
     * 自定义渲染按钮组
     */
    functionsRender(node, data) {
      const btns = [
        {
          label: this.$t('biz_shoptour_curr_all_area').d('当前全部'),
          handler: this.checkAll,
          disabled: !data.edit
        },
        {
          label: node.checked
            ? this.$t('biz_shoptour_cancel_curr_area').d('取消当前节点区域')
            : this.$t('biz_shoptour_curr_area').d('当前节点区域'),
          handler: node.checked
            ? this.cancelCurrentNode
            : this.checkCurrentNode,
          disabled: !data.edit
        }
      ];
      return btns;
    },
    /**
     * 节点点击事件
     */
    nodeClick(...p) {
      console.log('p', p);
    },
    /**
     * checkbox勾选事件
     */
    handlerCheck(...argu) {
      const node = this.$refs.tree.getNode(argu[0]);
      // check-strictly 但是有要求点击checkbox时父子联动
      if (this.checkedLinkage === '1') {
        if (node.checked) {
          this.setChildrenInclude(node, node.data, 1, false);
        } else {
          this.setChildrenInclude(node, node.data, 0, true);
        }
      }
      this.$emit('check', ...argu);
    },
    /**
     * 设置后继节点状态
     */
    setChildrenInclude(node, data, includeAll = 1, f) {
      let descendantNodes = this.getDescendantNodes(node, includeAll);
      const checkedNodes = this.$refs.tree
        .getCheckedNodes()
        .filter(n => n.id !== data.id);
      if (!f) {
        // 如果descendantNodes已经存在于checkedNodes中, 那么把它从descendantNodes中去除
        descendantNodes = descendantNodes.filter(
          item => !checkedNodes.some(n => n.id === item.id)
        );
        this.currentCheckedNodes = [...descendantNodes, ...checkedNodes];
      } else {
        this.currentCheckedNodes = this.currentCheckedNodes.filter(
          n => !descendantNodes.some(item => item.id === n.id)
        );
      }
      this.$refs.tree.setCheckedNodes(this.currentCheckedNodes);
      this.$emit('update:list', this.currentCheckedNodes);
      this.$emit('includeChanged', node, data);
    },

    /**
     * 获取后续
     */
    getDescendantNodes(node, includeAll, accu = []) {
      node.data.edit === 1 && accu.push(node.data);
      if (!node.childNodes.length) return accu;
      node.childNodes.forEach(n => {
        this.getDescendantNodes(n, includeAll, accu);
      });
      return accu;
    },
    /**
     * 选中当前全部节点
     */
    checkAll(node, data) {
      this.setChildrenInclude(node, data, 1, false);
    },
    /**
     * 仅选中当前节点区域
     */
    checkCurrentNode(node, data) {
      this.currentCheckedNodes = [...this.currentCheckedNodes, data];
      this.$refs.tree.setCheckedNodes(this.currentCheckedNodes);
      this.$emit('update:list', this.currentCheckedNodes);
    },
    /**
     * 仅取消当前区域
     */
    cancelCurrentNode(node, data) {
      this.currentCheckedNodes = this.currentCheckedNodes.filter(
        n => n.id !== data.id
      );
      this.$refs.tree.setCheckedNodes(this.currentCheckedNodes);
      this.$emit('update:list', this.currentCheckedNodes);
    },
    getAreaTree() {
      getAreaTree()
        .then(res => {
          this.data = res.datas;
          this.$nextTick(() => {
            if (this.list.length > 0) {
              this.currentCheckedNodes = this.list;
              this.$refs.tree.setCheckedNodes(this.currentCheckedNodes);
              this.$refs.tree.getCheckedNodes().forEach(item => {
                if (this.list.findIndex(ele => ele.id === item.id) === -1) {
                  this.$refs.tree.setChecked(item.id, false);
                }
              });
            }
            if (res.datas[0]) {
              this.expendedRoot = [res.datas[0].id];
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
